import AddDoctor from "./AddDoctor/AddDoctor";
import ViewDoctor from "./ViewDoctor/ViewDoctor";
import RecapitiDoctor from "./RecapitiDoctor/RecapitiDoctor";
import {
  useGetDoctorById,
  useGetDoctors,
  usePutDoctorById,
  useNewDoctor,
  useDeleteDoctor,
} from "./useDoctorQueries";

// == represents profiles Enum on the ws ==
const profiles = [
  { label: "altro", id: 1 },
  { label: "cardiologo", id: 2 },
  { label: "pneumologo", id: 3 },
  { label: "medico_di_base", id: 4 },
  { label: "dietologo", id: 5 },
  { label: "covid_19", id: 6 },
  { label: "psichiatra", id: 7 },
  { label: "gastroenterologo", id: 8 },
  { label: "chirurgo", id: 9 },
  { label: "ortopedico", id: 10 },
  { label: "diabetologo", id: 11 },
  { label: "fisiatra", id: 12 },
];

export {
  AddDoctor,
  ViewDoctor,
  RecapitiDoctor,
  useGetDoctorById,
  profiles,
  useGetDoctors,
  usePutDoctorById,
  useNewDoctor,
  useDeleteDoctor,
};
